<app-header text='default'></app-header>
<div id="content">
  <div id="readspeaker_button1" class="rs_skip rsbtn rs_preserve" *ngIf="env.readspeaker.enabled">
    <a rel="nofollow" class="rsbtn_play" accesskey="L" i18n-title="@@readSpeakerDescription" title="Listen to this page using ReadSpeaker webReader" [href]="getReadSpeakerURL('content')">
        <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span i18n="@@readSpeakerListen">Listen</span></span></span>
        <span class="rsbtn_right rsimg rsplay rspart"></span>
    </a>
  </div>
  <div class="heading" i18n="">Skills Checker Cookie Policy</div>
  <div class="container">
    <p i18n="">Check-In, Take-Off (CITO) is an Erasmus+ project. Erasmus+ projects are funded by the European Commission. Erasmus+ fund organisations across Europe to work and learn together to improve education and training in their individual countries. The CITO project team is comprised of organisations from three countries, Malta, Ireland and Norway; the Directorate for Research, Lifelong Learning and Employability (Malta), the National Adult Literacy Agency (Ireland), Education and Training Boards Ireland (Ireland), Waterford Institute of Technology (Ireland) and Fønix (Norway).</p>
    
    <p i18n="">The CITO project team respect the rights of users of the Skills Checker. The Skills Checker is currently hosted at the following domains:</p>

    <ul class="nobullet">
      <li><a href="https://www.skillschecker.ie">www.skillschecker.ie</a></li>
      <li><a href="https://www.skillschecker.mt">www.skillschecker.mt</a></li>
      <li><a href="https://www.skillschecker.no">www.skillschecker.no</a></li>
    </ul>

    <p i18n="">We are committed to protecting your privacy in line with the Data Protection Acts 1988 and 2003 and General Data Protection Regulation (GDPR) 2018 at all times. We will not collect any personal data ( information) about you on this site without your permission or otherwise. This is in line with the Data Protection Acts 1988 and 2003 and General Data Protection Regulation (GDPR) 2018.</p>

    <h3 i18n="">Technical data we collect</h3>

    <p i18n="">By simply visiting our site, you do not disclose (share), nor do we collect, personal data about you. The information collected about your visit is limited to technical data like:</p>

    <ul>
      <li i18n="">the Internet address (or IP address) of the device you used to access our site;</li>
      <li i18n="">whether you reached our site using a search engine or if you clicked a link on another website; and</li>
      <li i18n="">the type of web browser you used and the type of device you used to access the Internet.</li>
    </ul>

    <h3 i18n="">How we use technical information</h3>

    <p i18n="">We use technical data for administrative and statistical purposes as well as to help us improve our site. This technical data does not provide us with the personal data of visitors to our site.</p>

    <h2 i18n="@@COOKIES">Cookies</h2>

    <h3 i18n="">Cookies we use</h3>

    <p i18n="">A cookie is a small piece of data (text file) that a website – when visited by a user – asks your browser to store on your device in order to remember information about you, such as your language preference or login information. Those cookies are set by us and called first-party cookies. More specifically, we use cookies and other tracking technologies for the following purposes:</p>

    <h3 i18n="">Strictly Necessary Cookies</h3>

    <p i18n="">These cookies are necessary for the Skills Checker to function and cannot be switched off in our systems. They are usually only set in response to actions made by you, such as setting your privacy preferences. You can set your browser to block or alert you about these cookies, but if you do so some parts of the site will not work. These cookies do not store any personally identifiable information.</p>

    <table>
      <thead>
        <tr><th i18n="@@COOKIESUBGROUP">Cookie Subgroup</th><th i18n="@@COOKIES">Cookies</th><th i18n="@@COOKIESUSED">Cookies used</th><th i18n="@@LIFESPAN">Lifespan</th></tr>
      </thead>
      <tbody>
        <tr><td>skillschecker.ie</td><td>cookieconsent_status</td><td i18n="@@FIRSTPARTY">First party</td><td i18n="@@SESSION">Session</td></tr>
        <tr><td>skillschecker.no</td><td>cookieconsent_status</td><td i18n="@@FIRSTPARTY">First party</td><td i18n="@@SESSION">Session</td></tr>
        <tr><td>skillschecker.mt</td><td>cookieconsent_status</td><td i18n="@@FIRSTPARTY">First party</td><td i18n="@@SESSION">Session</td></tr>
      </tbody>
    </table>

    <h3 i18n="">Performance Cookies</h3>

    <p i18n="">These cookies allow us to count visits and traffic sources (how you ended up on the Skills Checker) so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.</p>

    <table>
      <thead>
        <tr><th i18n="@@COOKIESUBGROUP">Cookie Subgroup</th><th i18n="@@COOKIES">Cookies</th><th i18n="@@COOKIESUSED">Cookies used</th><th i18n="@@LIFESPAN">Lifespan</th></tr>
      </thead>
      <tbody>
        <tr>
          <td>skillschecker.ie</td>
          <td class="preformatted">
            _ga<br/> 
            _gat_gtag_UA-XXXXXXXX_X<br/>
            _gid
          </td>
          <td i18n="@@FIRSTPARTY">First party</td>
          <td>
            <span i18n="@@730DAYS">730 days</span><br/>
            <span i18n="@@AFEWSECONDS">a few second</span>s<br/>
            <span i18n="@@1DAY">1 day</span>
          </td>
        </tr>
        <tr>
          <td>skillschecker.no</td>
          <td class="preformatted">
            _ga<br/>
            _gat_gtag_UA-XXXXXXXX_X<br/>
            _gid
          </td>
          <td i18n="@@FIRSTPARTY">First party</td>
          <td>
            <span i18n="@@730DAYS">730 days</span><br/>
            <span i18n="@@AFEWSECONDS">a few seconds</span><br/>
            <span i18n="@@1DAY">1 day</span>
          </td>
        </tr>
        <tr>
          <td>skillschecker.mt</td>
          <td class="preformatted">
            _ga<br/>
            _gat_gtag_UA-XXXXXXXX_X<br/>
            _gid
        </td>
          <td i18n="@@FIRSTPARTY">First party</td>
          <td>
            <span i18n="@@730DAYS">730 days</span><br/>
            <span i18n="@@AFEWSECONDS">a few seconds</span><br/>
            <span i18n="@@1DAY">1 day</span>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</div>
<div class="footer">
  <app-navigate-button text="default" destination=""></app-navigate-button>
</div>
